import { HealthSystemSetup } from "./HealthSystemSetup";
import { UserRole } from "./UserRole";



export class HealthOrganizationSetupDomain {
  id: number;
  name: string;
  isProfileSetUpCompleted: boolean;
  healthSystems: HealthSystemSetup[] = [];
  userRoles: UserRole[] =[];
  healthOrganizationTypeId:number;

  constructor() {
    this.id = 0;
    this.name = '';
    this.isProfileSetUpCompleted = false;
    this.healthSystems = [];
    this.userRoles = [];
    this.healthOrganizationTypeId = 1;
  }
}


